import React from "react";

interface WeekDaysSelectorProps {
  days: number[]; // 1=Mon, 7=Sun
  onChange?: (days: number[]) => void;
  type?: string; // custom/school
  className?: string;
  small?: boolean;
}

const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

const WeekDaysSelector: React.FC<WeekDaysSelectorProps> = ({ days, onChange, type = "custom", className, small = false }) => {
  // 只读模式
  const readOnly = !onChange;

  const handleToggle = (dayNum: number) => {
    if (readOnly) return;
    if (days.includes(dayNum)) {
      onChange && onChange(days.filter((d) => d !== dayNum));
    } else {
      onChange && onChange([...days, dayNum]);
    }
  };

  return (
    <div className={`flex flex-row ${className || ""} ${small ? "gap-1" : "gap-2"}`}>
      {weekDays.map((label, idx) => {
        const dayNum = idx; // 1~7
        const isActive = days.includes(dayNum);
        return (
          <div
            key={dayNum}
            className={`display-text-bold ${small ? "w-6 h-6 text-sm" : "w-8 h-8 text-lg"} flex items-center justify-center rounded-full font-bold select-none transition-colors duration-150
              ${isActive
                ? type === "custom"
                  ? "bg-teal-500 text-white"
                  : "bg-blue-500 text-white"
                : "bg-gray-100 text-gray-400"}
              ${readOnly ? "cursor-default" : "cursor-pointer hover:opacity-80"}`}
            onClick={() => handleToggle(dayNum)}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default WeekDaysSelector; 